import { render, staticRenderFns } from "./OkToAnswerFoodForm.vue?vue&type=template&id=d9bb610e"
import script from "./OkToAnswerFoodForm.vue?vue&type=script&lang=js"
export * from "./OkToAnswerFoodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports